import React from 'react'

const ResponseMessage = ( props ) => {

  const type = props.response.type ?? ''
  const message = props.response.message ?? ''

  return (
    <div className={`msync-modal__message msync-modal__message-${ type }`}>
        <div className='msync-modal__message__response'>
            <span>{ message }</span>
        </div>
    </div>
  )
}

export default ResponseMessage